import { NavLink } from "react-router-dom";
import { useViewRole } from "../../context/ViewRoleContext";
import {
  LayoutDashboard,
  Hammer,
  KanbanSquare,
  FileSpreadsheet,
  PackageSearch,
  Users2,
  BarChart3,
  PieChart,
  Store,
  Settings,
  FileUp,
  PhoneCall,
  Sparkles,
  Crosshair,
} from "lucide-react";

const NAV = [
  { to: "/ma-journee", label: "Ma Journée", icon: Crosshair, testId: "nav-item-today" },
  { to: "/", label: "Tableau de Bord", icon: LayoutDashboard, testId: "nav-item-dashboard", end: true },
  { to: "/assistant", label: "Assistant", icon: Sparkles, testId: "nav-item-assistant", badge: "IA" },
  { to: "/chantiers", label: "Rentabilité Chantiers", icon: Hammer, testId: "nav-item-chantiers" },
  { to: "/pipeline", label: "Pipeline Opportunités", icon: KanbanSquare, testId: "nav-item-pipeline" },
  { to: "/actions", label: "Actions Commerciales", icon: PhoneCall, testId: "nav-item-actions" },
  { to: "/devis", label: "Devis & Chiffrage", icon: FileSpreadsheet, testId: "nav-item-devis" },
  { to: "/catalogue", label: "Catalogue Prestations", icon: PackageSearch, testId: "nav-item-catalogue" },
  { to: "/clients", label: "Clients & Contacts", icon: Users2, testId: "nav-item-clients" },
  { to: "/analytics", label: "Module d'Analyse", icon: BarChart3, testId: "nav-item-analytics", badge: "Expert" },
  { to: "/statistiques", label: "Statistiques", icon: PieChart, testId: "nav-item-stats" },
  { to: "/business-hunter", label: "Business Hunter", icon: Crosshair, testId: "nav-item-hunter", badge: "New" },
];

export default function Sidebar() {
  const { effectiveRole } = useViewRole();
  const renderItem = (item) => {
    const Icon = item.icon;
    return (
      <NavLink key={item.to} to={item.to} end={item.end} data-testid={item.testId}
        className={({ isActive }) => `group flex items-center gap-3 px-3 py-2.5 rounded-lg text-[14px] font-medium transition-all duration-150 ${isActive ? "crm-nav-active" : "crm-nav-item"}`}>
        <Icon className="shrink-0" style={{ height: 18, width: 18 }} />
        <span className="flex-1 truncate">{item.label}</span>
        {item.badge && <span className="crm-nav-badge">{item.badge}</span>}
      </NavLink>
    );
  };
  const quotidien = NAV.filter(x => ["/", "/ma-journee", "/devis", "/clients", "/actions"].includes(x.to));
  const activite = NAV.filter(x => ["/pipeline", "/chantiers", "/catalogue"].includes(x.to));
  const pilotage = NAV.filter(x => ["/analytics", "/statistiques"].includes(x.to));
  const outils = NAV.filter(x => ["/business-hunter", "/assistant"].includes(x.to));
  return (
    <aside className="hidden lg:flex flex-col fixed inset-y-0 left-0 w-64 bg-white border-r border-[#E5EDF6] z-30">
      <div className="crm-brand-panel">
        <img src="/bricomarche-logo.png" alt="Bricomarché" className="crm-brand-logo" />
        <div className="crm-brand-city">BOLLÈNE</div>
        <div className="crm-brand-subtitle">CRM</div>
      </div>
      <nav className="flex-1 px-4 py-5 overflow-y-auto crm-sidebar-scroll">
        <div className="crm-nav-section"><div className="crm-nav-section-title">QUOTIDIEN</div><div className="space-y-1">{quotidien.map(renderItem)}</div></div>
        <div className="crm-nav-section"><div className="crm-nav-section-title">ACTIVITÉ</div><div className="space-y-1">{activite.map(renderItem)}</div></div>
        <div className="crm-nav-section"><div className="crm-nav-section-title">PILOTAGE</div><div className="space-y-1">{pilotage.map(renderItem)}</div></div>
        <div className="crm-nav-section">
          <div className="crm-nav-section-title">MÉMOIRE</div>
          <div className="space-y-1">
            <NavLink to="/archives" data-testid="nav-item-archives"
              className={({ isActive }) => `group flex items-center gap-3 px-3 py-2.5 rounded-lg text-[14px] font-medium transition-all duration-150 ${isActive ? "crm-nav-active" : "crm-nav-item"}`}>
              <FileSpreadsheet className="shrink-0" style={{height:18,width:18}} /><span className="flex-1">Archives</span>
            </NavLink>
          </div>
        </div>
        <div className="crm-nav-section"><div className="crm-nav-section-title">OUTILS</div><div className="space-y-1">{outils.map(renderItem)}</div></div>
        {effectiveRole === "admin" && <div className="crm-nav-section">
          <div className="crm-nav-section-title">ADMINISTRATION</div><div className="space-y-1">
            <NavLink to="/admin" data-testid="nav-item-admin" className={({ isActive }) => `group flex items-center gap-3 px-3 py-2.5 rounded-lg text-[14px] font-medium transition-all duration-150 ${isActive ? "crm-nav-active" : "crm-nav-item"}`}>
              <Settings className="shrink-0" style={{height:18,width:18}} /><span className="flex-1">Administration</span>
            </NavLink>
            <NavLink to="/import" data-testid="nav-item-import" className={({ isActive }) => `group flex items-center gap-3 px-3 py-2.5 rounded-lg text-[14px] font-medium transition-all duration-150 ${isActive ? "crm-nav-active" : "crm-nav-item"}`}>
              <FileUp className="shrink-0" style={{height:18,width:18}} /><span className="flex-1">Import Excel</span>
            </NavLink>
          </div>
        </div>}
      </nav>
      <div className="p-4 border-t border-[#E5EDF6]">
        <div className="crm-sidebar-tip"><div className="crm-sidebar-tip-icon">⌁</div><div><div className="font-semibold text-[12px] text-[#17365D]">Conduisons vos succès</div><div className="text-[11px] text-[#6B86A3]">ensemble !</div></div></div>
        <p className="text-[10px] text-[#8AA0B8] mt-3 text-center">© 2026 Bricomarché CRM</p>
      </div>
    </aside>
  );
}
